import React, { useState, useEffect } from 'react';
import HotChartServices from '../../../services/HotChartServices';

function HotChartUpdate({ hotchart, closeModal, onSuccess }) {
  const [formValues, setFormValues] = useState({
    symbol: '',
    description: '',
    image: '',
  });
  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  useEffect(() => {
    if (hotchart) {
      const { symbol = '', description = '', image = '' } = hotchart;
      setFormValues({ symbol, description, image });
      if (image) {
        setPreviewImage(process.env.REACT_APP_URL + image);
      }
    }
  }, [hotchart]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPreviewImage(URL.createObjectURL(file));
      setFormValues((prev) => ({ ...prev, image: file }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      for (const key in formValues) {
        formData.append(key, formValues[key]);
      }

      await HotChartServices.updateHotChart(hotchart._id, formData);
      alert('HotChart updated successfully');
      onSuccess();
    } catch (err) {
      console.error('Update failed:', err);
      alert('Failed to update HotChart');
    }
  };

  return (
    <div className="modal fade edit-box show d-block" tabIndex={-1} aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Edit HotChart</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <form onSubmit={handleSubmit} className="px-5">
              <div className="row g-3">
                <div className="col-lg-9 col-md-6">
                  <label className="form-label">Symbol</label>
                  <input
                    type="text"
                    name="symbol"
                    className="form-control"
                    value={formValues.symbol}
                    onChange={handleInputChange}
                    placeholder="Enter symbol"
                    required
                  />
                </div>

                <div className="col-lg-9 col-md-6">
                  <label className="form-label">Description</label>
                  <input
                    type="text"
                    name="description"
                    className="form-control"
                    value={formValues.description}
                    onChange={handleInputChange}
                    placeholder="Enter description"
                  />
                </div>

                <div className="col-sm-9">
                  <label className="form-label">Upload Image <span className="text-danger">*</span></label>
                  <input
                    type="file"
                    name="image"
                    className="form-control"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                  <small className="text-muted d-block mt-1">
                    Supported: png, jpeg, jpg, webp. Max resolution 1500x1500px.
                  </small>
                  <div className="file-preview text-center mt-2">
                    <img src={previewImage} alt="Preview" style={{ maxWidth: '100%', maxHeight: 200 }} />
                  </div>
                </div>

                <div className="col-12 mt-3">
                  <button type="submit" className="btn btn-success">Update HotChart</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HotChartUpdate;
